import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import HomePage from "@/pages/HomePage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import TrackBooking from "@/pages/TrackBooking";
import ProtectedRoute from "@/components/ProtectedRoute";
import { AuthProvider } from "@/context/AuthContext";
import ChatWidget from "@/components/site/ChatWidget";

function ChatMount() {
  const { pathname } = useLocation();
  // Hide on admin routes — admins have their own dashboard tools
  if (pathname.startsWith("/admin")) return null;
  return <ChatWidget />;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/track" element={<TrackBooking />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route
              path="/admin/dashboard"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
          </Routes>
          <ChatMount />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
